/*
  Koszyk — jeden blok polecanych akcesoriów z zakładkami (CRO pkt 10).

  Slajdy są renderowane przez Liquid do ukrytej puli (.eva-upsell__pool) z atrybutem
  data-upsell-tab. Tutaj przenosimy do slidera tylko te z aktywnej zakładki i re-inicjujemy
  Swiper motywu (window.initDrawerProgressUpsell) — dzięki temu nie tworzymy drugiej instancji
  slidera ani nie duplikujemy logiki dodawania do koszyka.

  Blok jest wewnątrz .js-contents, więc po każdej zmianie koszyka sekcja jest przerysowywana —
  dlatego wypełniamy go ponownie na zdarzenie cartUpdate motywu.
*/
(function () {
  'use strict';

  var ACTIVE = 'is-active';
  var ACTIVE_VARIANT = 'active';

  function fill(block, tabId) {
    var wrapper = block.querySelector('[data-upsell-wrapper]');
    var pool = block.querySelector('.eva-upsell__pool');
    if (!wrapper || !pool) return;

    var items = pool.querySelectorAll('.eva-upsell__pool-item[data-upsell-tab="' + tabId + '"]');
    wrapper.innerHTML = '';
    Array.prototype.forEach.call(items, function (poolItem) {
      var slide = poolItem.querySelector('.swiper-slide');
      if (slide) wrapper.appendChild(slide.cloneNode(true));
    });

    block.querySelectorAll('.eva-upsell__tab').forEach(function (tab) {
      var on = tab.getAttribute('data-upsell-tab') === tabId;
      tab.classList.toggle(ACTIVE, on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    block.setAttribute('data-active-tab', tabId);

    var root = block.querySelector('.drawer__progress_products');
    if (root && window.initDrawerProgressUpsell) window.initDrawerProgressUpsell(root);
  }

  function init() {
    document.querySelectorAll('[data-upsell-tabs]').forEach(function (block) {
      var first = block.querySelector('.eva-upsell__tab');
      if (!first) return;
      fill(block, block.getAttribute('data-active-tab') || first.getAttribute('data-upsell-tab'));
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var tab = e.target.closest('.eva-upsell__tab');
    if (!tab) return;
    var block = tab.closest('[data-upsell-tabs]');
    if (!block) return;
    e.preventDefault();
    fill(block, tab.getAttribute('data-upsell-tab'));
  });

  /* wybór wariantu na kafelku */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var chip = e.target.closest('.eva-upsell .product__upsell_item_variant');
    if (!chip || chip.classList.contains('disabled')) return;
    var group = chip.closest('.product__upsell_item_variants');
    if (!group) return;
    group.querySelectorAll('.product__upsell_item_variant').forEach(function (el) {
      el.classList.remove(ACTIVE_VARIANT);
    });
    chip.classList.add(ACTIVE_VARIANT);
  });

  /* „Dodaj” — kafelek leży wewnątrz formularza koszyka, więc bez preventDefault
     przycisk submitowałby cały formularz zamiast dodać produkt. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var button = e.target.closest('.eva-upsell .product-form__submit');
    if (!button || button.disabled) return;
    e.preventDefault();

    var item = button.closest('.product__upsell_item');
    if (!item) return;
    var active = item.querySelector('.product__upsell_item_variant.' + ACTIVE_VARIANT);
    var variantId = active ? active.dataset.id : item.dataset.id;
    if (!variantId) return;

    button.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add.js ' + r.status);
        return r.json();
      })
      .then(function (dodany) {
        button.disabled = false;
        /* Bez przeladowania strony. Wczesniej bylo tu `window.location.reload()`:
           produkt sie dodawal, ale strona odbudowywala sie od zera, wiec klient
           widzial mrugniecie, a komunikat „Dodano” ginal razem ze strona.
           Teraz przerysowujemy same sekcje koszyka i dopiero PO potwierdzeniu
           z serwera pokazujemy komunikat. */
        var koniec = window.evmOdswiezKoszyk ? window.evmOdswiezKoszyk() : Promise.resolve();
        return koniec.then(function () {
          document.dispatchEvent(new CustomEvent('evm:dodano', {
            detail: { nazwa: (dodany && (dodany.product_title || dodany.title)) || '' }
          }));
        });
      })
      .catch(function (err) {
        console.error('[cart-upsell-tabs]', err);
        if (window.evmPokazBladKoszyka) window.evmPokazBladKoszyka();
        button.disabled = false;
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Po każdej zmianie koszyka motyw podmienia zawartość .js-contents — slider wraca wtedy
     pusty. Nie opieramy się na pub/sub motywu (PUB_SUB_EVENTS nie jest globalne w tym theme),
     tylko obserwujemy DOM i uzupełniamy slider, gdy tylko zostanie wyczyszczony. */
  var observer = new MutationObserver(function () {
    document.querySelectorAll('[data-upsell-tabs]').forEach(function (block) {
      var wrapper = block.querySelector('[data-upsell-wrapper]');
      if (!wrapper || wrapper.children.length) return;
      var active = block.getAttribute('data-active-tab');
      var first = block.querySelector('.eva-upsell__tab');
      if (!active && first) active = first.getAttribute('data-upsell-tab');
      if (active) fill(block, active);
    });
  });

  function watch() {
    var scope = document.getElementById('main-cart-items') || document.body;
    observer.observe(scope, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
